import { Tabs } from '@medly-components/core';
import { useUserContext } from 'context/UserContext';
import { AssignedRegion } from 'context/UserContext/types';
import { useState } from 'react';
import MapDetails from '../../MapDetails';
import { type AssignedMaps } from '../AssignedMaps';
import { Container, Maps } from './MapsTabsView.styled';

type GroupedItems = {
    [key: string]: AssignedRegion[];
};

type MapsTabsView = {
    onZoneClick: AssignedMaps['onZoneClick'];
};
export const MapsTabsView = ({ onZoneClick }: MapsTabsView) => {
    const { user } = useUserContext();
    const mapsGroupWithCancerType = user!.assignedRegions!.reduce((acc: GroupedItems, region) => {
        const mapName = region.mapName;
        if (!acc[mapName]) {
            acc[mapName] = [];
        }
        acc[mapName].push(region);

        return acc;
    }, {});
    const [selecteMap, setSelectedMap] = useState(user!.assignedRegions![0].mapName);
    const selectedRegions = mapsGroupWithCancerType[selecteMap];

    return (
        <Container>
            <Tabs hidePanel active={selecteMap} onChange={id => setSelectedMap(id)}>
                {Object.keys(mapsGroupWithCancerType).map(mapName => (
                    <Tabs.Tab data-testid={mapName} key={mapName} id={mapName} label={mapName} />
                ))}
            </Tabs>
            <Maps>
                {selectedRegions.map(assignedRegion => (
                    <MapDetails key={assignedRegion.id} userId={user!.id} regionId={assignedRegion.id} onZoneClick={onZoneClick} />
                ))}
            </Maps>
        </Container>
    );
};
